export const BASE_MODELS = [
  { key: "users", name: "Usuarios", icon: "👤" },
  { key: "clients", name: "Clientes", icon: "👥" },
  { key: "products", name: "Productos", icon: "📦" },
  { key: "productLines", name: "Líneas de Producto", icon: "📋" },
  { key: "invoices", name: "Facturas", icon: "📄" },
  { key: "turnos", name: "Turnos", icon: "🕐" },
  { key: "cajas", name: "Cajas", icon: "💰" },
  { key: "aperturaDeCaja", name: "Aperturas de Caja", icon: "🔓" },
  { key: "cierreDeCaja", name: "Cierres de Caja", icon: "🔒" },
  { key: "formasPago", name: "Formas de Pago", icon: "💳" },
  { key: "colegios", name: "Colegios", icon: "🏫" },
  { key: "tpvs", name: "Tiendas", icon: "🏪" },
  { key: "coupons", name: "Cupones", icon: "🎫" },
  { key: "campaigns", name: "Campañas", icon: "📢" },
  { key: "salesPrices", name: "Precios de Venta", icon: "💰" },
  { key: "grupoIVA", name: "Grupo IVA", icon: "🧾" },
  { key: "divisas", name: "Divisas", icon: "💱" },
  { key: "empresa", name: "Empresa", icon: "🏢" },
  { key: "vendedores", name: "Vendedores", icon: "💼" },
  // Al final de la lista a propósito: getModels() concatena los `include`
  // de MODELS_BY_COUNTRY después de BASE_MODELS, así que dejar este acá es
  // lo único que logra que la caja de Perú "Grupos de Descuento de
  // Cliente" (modelsByCountry.js) quede justo después de esta en la UI.
  { key: "gruposPrecioCliente", name: "Grupos de Precio de Cliente", icon: "💲" },
  { key: "grupoCajeros", name: "Grupos de Cajero", icon: "🧑‍💼" },
  { key: "puestos", name: "Puestos", icon: "🏷️" },
];
